import $ from 'jquery';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import _t from './translate';
import checkMetamask from './checkMetamask';
import getNfsgxContract from './getNfsgxContract';
import showAlert from './showAlert';
import {
  checkDeposit,
} from './api';

const stakeNfsgxTokens = async () => {
  const marketplaceElements = $('.js-stake-nfsgx-tokens');
  if (!marketplaceElements.length) {
    return;
  }

  marketplaceElements.on('click', (e) => {
    const walletType = $(e.currentTarget).data('wallet-type');

    Swal.fire({
      html: `<p style="margin-top: 50px;">${_t('How much $NFSGX token you want to transfer?')}</p>`,
      title: 'Deposit',
      input: 'number',
      inputValidator: result => !result && _t('You need to enter value'),
      inputAttributes: {
        autocapitalize: 'off',
      },
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: _t('Send'),
      showLoaderOnConfirm: true,
      preConfirm: async (value) => {
        if (!await checkMetamask()) {
          return;
        }

        const accounts = await web3Client.eth.getAccounts();
        const address = accounts[0];

        if (value < 1) {
          showAlert({ message: _t(`Minimum tranfer amount is %s ${walletType}`).replace('%s', '1'), icon: 'error' });
        } else {
          const amount = value * 1000000;

          let response;

          const contract = getNfsgxContract();
          await contract.methods.deposit(amount).send(0, {
            from: address,
            maxPriorityFeePerGas: null,
            maxFeePerGas: null,
          });

          try {
            const res = await checkDeposit({
              data: {
                blockNumber: response.blockNumber,
              },
            });
            if (res.data.success) {
              showAlert({ message: _t('Transfer succeeded'), icon: 'success' });
              document.location.reload(true);
            } else {
              showAlert({ message: _t('Not approved yet, please try again later'), icon: 'error' });
            }
            return res;
          } catch (error) {
            showAlert({ message: _t('Not approved yet, please try again later'), icon: 'error' });
          }
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value && result.value.status) {
          Swal.fire(
            _t('Success!'),
            'Send',
            'success',
          );
          document.location.reload(true);
        }
      }
    });
  });
};

export default stakeNfsgxTokens;
